import { render } from "./CetaMarge.vue?vue&type=template&id=2e08b970&scoped=true&ts=true"
import script from "./CetaMarge.vue?vue&type=script&lang=ts"
export * from "./CetaMarge.vue?vue&type=script&lang=ts"

import "./CetaMarge.vue?vue&type=style&index=0&id=2e08b970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e08b970"]])

export default __exports__